import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getAcceptedConnectionProfiles } from "../../services/connectionsService";
import "./Connections.css";

function Connections() {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [connections, setConnections] = useState([]);

    useEffect(() => {
        const loadConnections = async () => {
            setLoading(true);
            setError("");
            try {
                const data = await getAcceptedConnectionProfiles();
                setConnections(data || []);
            } catch (err) {
                console.error("Error loading connections", err);
                setError("Could not load your connections right now.");
                setConnections([]);
            } finally {
                setLoading(false);
            }
        };

        loadConnections();
    }, []);

    return (
        <main className="page connections-page">
            <div className="connections-shell">
                <div className="connections-header">
                    <div>
                        <h1>Your Connections</h1>
                        <p>{connections.length} total connection{connections.length === 1 ? "" : "s"}</p>
                    </div>
                    <Link to="/explore" className="connections-back-link">Back to Explore</Link>
                </div>

                {loading && (
                    <section className="connections-card">
                        <p className="connections-muted">Loading connections...</p>
                    </section>
                )}

                {!loading && error && (
                    <section className="connections-card">
                        <p className="connections-error">{error}</p>
                    </section>
                )}

                {!loading && !error && connections.length === 0 && (
                    <section className="connections-card">
                        <p className="connections-muted">You have no accepted connections yet.</p>
                    </section>
                )}

                {!loading && !error && connections.length > 0 && (
                    <section className="connections-card">
                        <div className="connections-list-full">
                            {connections.map((connection) => {
                                const fullName = `${connection.first_name || ""} ${connection.last_name || ""}`.trim() || "Connection";
                                const initial = fullName.charAt(0).toUpperCase() || "C";
                                const roleLabel = (connection.role || "member").toString();
                                const role = roleLabel.charAt(0).toUpperCase() + roleLabel.slice(1);
                                const headline = connection.primary_position || role;
                                const meta = `${headline}${connection.city ? ` • ${connection.city}` : ""}`;

                                const content = (
                                    <>
                                        {connection.avatar_url ? (
                                            <img src={connection.avatar_url} alt={fullName} className="connections-avatar" />
                                        ) : (
                                            <div className="connections-avatar">{initial}</div>
                                        )}
                                        <div className="connections-content">
                                            <p className="connections-name">{fullName}</p>
                                            <p className="connections-meta">{meta}</p>
                                        </div>
                                        <span className="connections-action">
                                            {connection.has_public_player_profile ? "View profile" : "No public profile"}
                                        </span>
                                    </>
                                );

                                if (connection.has_public_player_profile) {
                                    return (
                                        <Link
                                            key={connection.user_id}
                                            to={`/player/${connection.user_id}`}
                                            className="connections-item connections-item-link"
                                        >
                                            {content}
                                        </Link>
                                    );
                                }

                                return (
                                    <div key={connection.user_id} className="connections-item connections-item-disabled">
                                        {content}
                                    </div>
                                );
                            })}
                        </div>
                    </section>
                )}
            </div>
        </main>
    );
}

export default Connections;
